import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/layouts/AppLayout";
import LoginPage from "@/pages/LoginPage";
import OverviewPage from "@/pages/OverviewPage";
import FacilitiesPage from "@/pages/FacilitiesPage";
import FacilityDetailPage from "@/pages/FacilityDetailPage";
import NPListPage from "@/pages/NPListPage";
import NPDetailPage from "@/pages/NPDetailPage";
import DirectorsPage from "@/pages/DirectorsPage";
import CNAsPage from "@/pages/CNAsPage";
import IssuesPage from "@/pages/IssuesPage";
import ClaimsPage from "@/pages/ClaimsPage";
import MeetingsPage from "@/pages/MeetingsPage";
import ImportExportPage from "@/pages/ImportExportPage";
import SmartImportPage from "@/pages/SmartImportPage";
import CoveragePlannerPage from "@/pages/CoveragePlannerPage";
import CoverageMapPage from "@/pages/CoverageMapPage";
import AiChatPage from "@/pages/AiChatPage";
import TodosPage from "@/pages/TodosPage";
import EnrichAddressesPage from "@/pages/EnrichAddressesPage";
import SettingsPage from "@/pages/SettingsPage";
import CptPricesPage from "@/pages/CptPricesPage";
import A1cReportPage from "@/pages/A1cReportPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<OverviewPage />} />
              <Route path="/facilities" element={<FacilitiesPage />} />
              <Route path="/facilities/:id" element={<FacilityDetailPage />} />
              <Route path="/nps" element={<NPListPage />} />
              <Route path="/nps/:id" element={<NPDetailPage />} />
              <Route path="/directors" element={<DirectorsPage />} />
              <Route path="/cnas" element={<CNAsPage />} />
              <Route path="/issues" element={<IssuesPage />} />
              <Route path="/claims" element={<ClaimsPage />} />
              <Route path="/meetings" element={<MeetingsPage />} />
              <Route path="/ai" element={<AiChatPage />} />
              <Route path="/todos" element={<TodosPage />} />
              <Route path="/enrich-addresses" element={<EnrichAddressesPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/cpt-prices" element={<CptPricesPage />} />
              <Route path="/outcomes/a1c" element={<A1cReportPage />} />
              <Route path="/coverage-planner" element={<CoveragePlannerPage />} />
              <Route path="/coverage-map" element={<CoverageMapPage />} />
              <Route path="/smart-import" element={<SmartImportPage />} />
              <Route path="/import-export" element={<ImportExportPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
